import {Component, ElementRef, Input, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {ArticlePricesService} from "../../data/article-prices.service";
import {TranslateService} from "../../../../services/multilingual/translate.service";
import {PriceService} from "../../../../services/price/price.service";
import {ArticlePricelistsService} from "../../data/article-pricelists.service";
import {ArticlesService} from "../../data/articles.service";
import {TokenService} from "../../../../services/auth/token.service";
import {LocalStorageService} from "../../../../services/storage/localstorage.service";
import {RefererService} from "../../../../services/storage/referer.service";
import {
  JBMTableActionDef, JBMTableColumnAlignment,
  JBMTableColumnDef,
  JBMTableColumnType, JBMTableComponent
} from "../../../../components/JBM/JBMTable/JBMTable.component";
import {JBMPropertiesListItem} from "../../../../components/JBM/Views/JBMPropertiesList/JBMPropertiesList.component";
import {QueryHttpHelper, SearchColumnType} from "../../../../components/JBM/Helpers/QueryHttpHelper";
import {Subscription} from "rxjs";
import {JBMToastsService} from "../../../../components/JBM/Views/JBMToasts/JBMToasts.service";
import {ModalService} from "../../../../components/JBM/JBMModal/service/modal.service";
import {HttpParams} from "@angular/common/http";
import {ArticlePricelist} from "../../data/interfaces/article-pricelist";
import {GroupRights} from '../../../users/data/interfaces/grouprights';

@Component({
  selector: 'article-prices',
  templateUrl: './article_prices.component.html',
  styleUrls: ['./article_prices.component.scss']
})
export class ArticlePricesComponent implements OnInit, OnDestroy {
  articlePricelist: ArticlePricelist;
  userRights: GroupRights;
  items: any;
  columnDefs: JBMTableColumnDef[];
  actionDefs: JBMTableActionDef[];
  language: string=this.TokenService.getLanguage();
  parentLinkCaption: string;
  parentLinkRoute: string;
  priceListProps: JBMPropertiesListItem[];
  id: number;
  details: any;
  loading: boolean=false;
  available: boolean=true;

  items$: Subscription;
  count$: Subscription;
  articlesCount$: Subscription;

  queryHttpHelper: QueryHttpHelper;
  searchboxVisible: boolean=true;
  search: string='';
  filtersVisible: boolean=false;

  @ViewChild('table') table: JBMTableComponent;
  @ViewChild('actionsTemplate') actionsTemplate: TemplateRef<any>;
  @ViewChild('modalContent') modalTemplate: ElementRef;

  constructor(
      private ActivatedRoute: ActivatedRoute,
      private ArticlePricesService: ArticlePricesService,
      private PriceService: PriceService,
      private ArticlePricelistsService: ArticlePricelistsService,
      private ArticlesService: ArticlesService,
      public modalService: ModalService,
      private TokenService: TokenService,
      private RefererService: RefererService,
      private TranslateService: TranslateService,
      private LocalStorageService: LocalStorageService,
      private JBMToastsService: JBMToastsService
  ) {
    // The route resolver has fetched the pricelist data
    this.articlePricelist=this.ActivatedRoute.snapshot.data.pricelist.data;
  }

  ngOnInit(): void {
    this.userRights = this.TokenService.getRightsByName('financial');

    this.columnDefs = [
      { name: 'id', type: JBMTableColumnType.id },
      { name: 'name', header: this.TranslateService.GetTranslation('entity.name'), sortable: true, filterable: true, width: 22},
      { name: 'description', header: this.TranslateService.GetTranslation('entity.description'), sortable: true, filterable: true },
      { name: 'price', type: JBMTableColumnType.price, header: this.TranslateService.GetTranslation('article.price'), sortable: true, width: 6 },
      { name: 'pricetype', header: this.TranslateService.GetTranslation('article.pricetype'), sortable: true, filterable: true, width: 7},
      { name: 'actions', type: JBMTableColumnType.boolean, align: JBMTableColumnAlignment.left, width: 15 }
    ];

    this.queryHttpHelper = new QueryHttpHelper();
    this.queryHttpHelper.addAliasedColumn('name','al.name');
    this.queryHttpHelper.addAliasedColumn('description','al.description');
    this.queryHttpHelper.addAliasedColumn('pricetype','aptl.code');
    this.queryHttpHelper.setSortColumn('name');
    this.queryHttpHelper.addSearchColumn('name', SearchColumnType.string);
    this.queryHttpHelper.addSearchColumn('description', SearchColumnType.string);
    this.queryHttpHelper.addSearchColumn('pricetype', SearchColumnType.string);

    // Set parent route
    this.parentLinkCaption=this.TranslateService.GetTranslation('financial.article-pricelists');
    this.parentLinkRoute='settings/financial/article-pricelists';

    // Set optional parent route from active referer
    let referer=this.RefererService.getReferer('customers','article-pricelists');
    if(typeof referer=='object') {
      this.parentLinkCaption=referer.caption;
      this.parentLinkRoute=referer.route;
    }
    setTimeout(()=> {
      this.queryHttpHelper.paginationProps.pageSize=this.table.getRowCount();
      this.getData(true);
    },100);
  }
  getData(countRows:boolean=false) {
    // Set pricelist properties
    let type=this.ArticlePricelistsService.getTypeAsString(this.articlePricelist.type, this.TranslateService);
    this.priceListProps=[];
    this.priceListProps.push({ label: this.TranslateService.GetTranslation('financial.article-pricelist'), value: this.articlePricelist.description });
    this.priceListProps.push({ label: this.TranslateService.GetTranslation('pricelist.type'), value: type });

    this.loading=true;
    let params=this.queryHttpHelper.getHttpParams(false);
    this.items$=this.ArticlePricesService.getData(this.language, this.articlePricelist.id, params).subscribe(
        (data: any) => this.items = data.data,()=>{},()=>{
          if(this.items.length)
            this.setDeletePermissions();

          // Set actions column template
          this.columnDefs[5].template=this.actionsTemplate;

          this.loading=false;
          if(countRows) {
            let params=this.queryHttpHelper.getHttpParams(true);
            this.count$=this.ArticlePricesService.getData(this.language, this.articlePricelist.id, params).subscribe(
                (data: any) => this.queryHttpHelper.paginationProps.itemCount = data.data,()=>{},()=>{} );
          }
        } );
  }
  rowCountChange(rowCount: any) {
    this.queryHttpHelper.paginationProps.pageSize=rowCount;
    this.getData();
  }
  setDeletePermissions() {
    let ids=[];
    for(let i=0; i<this.items.length; i++ ) {
      this.items[i].deletePermission=false;
      ids.push(this.items[i].id);
    }
    let deletePermissions=[];
    this.ArticlePricesService.getDeletePermissions(ids).subscribe(
        (data: any)=>deletePermissions=data.data,
        (error: any)=>console.error(error),
        ()=>{
          for(let i=0; i<this.items.length; i++ )
            this.items[i].deletePermission=(deletePermissions.indexOf(this.items[i].id)>-1);
        }
    )
  }
  pageChange(page: any) {
    this.queryHttpHelper.paginationProps.page=page;
    this.getData();
  }
  sortChange(event: any) {
    this.queryHttpHelper.setSortColumn(event.name, event.descending);
    this.getData();
  }
  searchChange(event: any) {
    let value=event.value;
    let minlength=event.minlength;
    value=value.length<minlength ? '' : value;
    if(this.queryHttpHelper.getSearchValue() != value) {
      this.queryHttpHelper.setSearchValue(value);
      this.getData(true);
    }
  }
  toggleFilters(event: any) {
    this.filtersVisible=!this.filtersVisible;
    this.queryHttpHelper.clearFilters();
    this.queryHttpHelper.setSearchValue('');
    this.getData(true);
  }
  filterChange(event: any) {
    this.queryHttpHelper.setFilterItem(event.name, event.value);
    this.getData(true);
  }
  addItem() {
    this.id=0;

    // Check availability of articles that do not belong to this pricelist
    let httpParams=new HttpParams();
    httpParams=httpParams.append('count','1');
    let articlesAvailable=false;
    this.articlesCount$=this.ArticlesService.getSelectList(this.language, this.articlePricelist.id, httpParams).subscribe(
        (data: any) => articlesAvailable=data.data>0, () => {
        }, () => {
          if(!articlesAvailable)
            this.JBMToastsService.error( this.TranslateService.GetTranslation('pricelist.no-articles-available'));
          else
            this.openModal();
        });
  }
  action(event: any) {
    this.rowSelect(event.row);
  }
  rowSelect(row: any) {
    this.id=row.id;
    this.details=row;
    this.openModal();
  }
  openModal() {
    this.modalService.open( this.modalTemplate,'article-price');
  }
  saved() {
    this.closeModal();
    this.JBMToastsService.success( this.TranslateService.GetTranslation('ui.entity-saved'));
    // Refresh view
    this.getData(true);
  }
  canceled() {
    this.closeModal();
  }
  closeModal() {
    this.modalService.close('article-price');
  }
  delete(id: any) {
    this.ArticlePricesService.delete(id).subscribe(
        ()=>{},(error: any)=>console.error(error),()=> {
          this.JBMToastsService.success( this.TranslateService.GetTranslation('ui.entity-deleted'));
          this.getData(true);
        }
    )
  }
  ngOnDestroy() {
    // Clean up observable subscriptions to avoid memory leaks
    if(this.items$!=undefined) this.items$.unsubscribe();
    if(this.count$!=undefined) this.count$.unsubscribe();
    if(this.articlesCount$!=undefined) this.articlesCount$.unsubscribe();
  }
}
